import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ScrollText, ShieldCheck } from "lucide-react";

const actionColor = (a) =>
  a.includes("write_off") || a.includes("override") || a.includes("pin") ? "bg-violet-500/15 text-violet-600 dark:text-violet-400 border-violet-500/30"
  : a.includes("payment") ? "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30"
  : a.includes("credit") ? "bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/30"
  : "bg-secondary text-muted-foreground border-border";

export default function AuditLog() {
  const [log, setLog] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setLog(r.data)); }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-head text-3xl font-extrabold flex items-center gap-2"><ScrollText className="w-7 h-7" /> Audit Log</h1>
        <p className="text-muted-foreground">Every sensitive action and manager approval is recorded here.</p>
      </div>

      <Card className="p-0 overflow-hidden">
        <Table>
          <TableHeader><TableRow>
            <TableHead>Time</TableHead><TableHead>User</TableHead><TableHead>Action</TableHead>
            <TableHead>Details</TableHead><TableHead>Approved By</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {log.map((a) => (
              <TableRow key={a.id} data-testid={`audit-row-${a.id}`}>
                <TableCell className="text-xs whitespace-nowrap">{fmtDate(a.created_at)}<br /><span className="text-muted-foreground">{new Date(a.created_at).toLocaleTimeString()}</span></TableCell>
                <TableCell className="font-medium">{a.user_name}</TableCell>
                <TableCell><Badge className={actionColor(a.action)}>{a.action}</Badge></TableCell>
                <TableCell className="text-sm text-muted-foreground">{a.details}</TableCell>
                <TableCell>{a.approver ? <span className="flex items-center gap-1 text-violet-500 text-sm"><ShieldCheck className="w-4 h-4" />{a.approver}</span> : "-"}</TableCell>
              </TableRow>
            ))}
            {log.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground py-10">No activity recorded yet.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
